import { createFileRoute } from '@tanstack/react-router'
import { AssetCreatePageBasic } from '../../../components/AssetCreatePage'
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs'
import { useAsset } from '../../../hooks/useQueries'

export const Route = createFileRoute('/$org/assets/createBasic')({
    component: AssetCreateBasic,
    validateSearch: (search: Record<string, unknown>) => {
        return {
            parent_asset_uid: search.parent_asset_uid as string | undefined,
            asset_type_uid: search.asset_type_uid as string | undefined,
            // Comma-separated list of asset_type UIDs the dropdown should be
            // limited to.
            //
            // DEPRECATED (spec 2026-05-05-01): the equipment-tab `+` button no
            // longer navigates here, and the asset-type field uses the
            // hierarchical picker for equipment parents. The param is kept
            // on the route for one release so existing deep-links still
            // resolve, but the legacy ApiSearchableSelect path that consumes
            // it will be removed once spec 2026-05-05-03 lands.
            restrict_to_uids: search.restrict_to_uids as string | undefined,
        }
    },
})

function AssetCreateBasic() {
    const { org } = Route.useParams()
    const search = Route.useSearch()

    // Fetch parent asset data if parent_asset_uid is provided
    const { data: parentAsset } = useAsset(org || 'demo', search.parent_asset_uid || '')

    // Build breadcrumbs dynamically based on whether there's a parent asset
    const breadcrumbs = [
        { title: 'Home', path: `/${org}` },
        { title: 'Assets', path: `/${org}/assets` }
    ]

    if (parentAsset) {
        breadcrumbs.push({
            title: parentAsset.name,
            path: `/${org}/assets/${parentAsset.uid}`
        })
    }

    breadcrumbs.push({ title: 'Create Asset', path: '' })

    useBreadcrumbs(breadcrumbs)

    return <AssetCreatePageBasic />
}